import { Observable } from "rxjs";
import moment from "moment";

import { SearchResults } from "../../../types/search/search-results.interface";
import { IFlyerFilters } from "../types/flyer-filter.interface";
import {
  IFlyerDetailData,
  IFlyerFilterOptions,
} from "../types/flyer-detail-data/flyer-detail-data.interface";
import { FlyerCreateForm } from "../types/flyer-create-form/flyer-create-form.interface";
import { FlyerCreateRequest } from "../types/flyer-create-request.interface";
import * as http from "../../../services/http.service";
import mapParameters from "../../../utils/mapParameters";
import { defaultParams, paramMap } from "../types/flyer.config";

export function create(form: FlyerCreateForm): Observable<IFlyerDetailData> {
  return http.post<IFlyerDetailData>("/flyers/", mapFlyerCreateFormToFlyerCreateRequest(form));
}

export function deleteFlyer(id: number): Observable<any> {
  return http.del<any>(`/flyers/${id}`);
}

export function fetchFilterOptions(): Observable<IFlyerFilterOptions> {
  return http.get<IFlyerFilterOptions>("/flyers/filter-options");
}

export function fetchFlyers(filters: IFlyerFilters): Observable<SearchResults<IFlyerDetailData>> {
  return http.get<SearchResults<IFlyerDetailData>>(
    "/flyers/",
    mapFlyerFetchFiltersToParams(filters)
  );
}

export const mapFlyerCreateFormToFlyerCreateRequest = (
  form: FlyerCreateForm
): FlyerCreateRequest => ({
  name: form.name,
  startAt: moment(form.startAt).format("YYYY-MM-DD"),
  endAt: moment(form.endAt).format("YYYY-MM-DD"),
  wtwReviewDate: moment(form.wtwReviewDate).format("YYYY-MM-DD"),
  wtwSeniorReviewDate: moment(form.wtwSeniorReviewDate).format("YYYY-MM-DD"),
});

export const mapFlyerFetchFiltersToParams = (filters: IFlyerFilters) => {
  const params: any = {};
  const mappedParams: any = mapParameters({ ...defaultParams, ...filters }, paramMap, false);

  Object.keys(mappedParams).forEach((param) => {
    params[param] = mappedParams[param][0];
  });

  return { params };
};
